import { lazy, Suspense } from "react";
import AuroraBackground from "@/components/AuroraBackground";
import Navbar from "@/components/Navbar";
import HookSection from "@/components/HookSection";
import SectionSkeleton from "@/components/SectionSkeleton";

// Lazy load below-the-fold sections
const USPSection = lazy(() => import("@/components/sections/USPSection"));
const ProcessSection = lazy(() => import("@/components/sections/ProcessSection"));
const AboutSection = lazy(() => import("@/components/sections/AboutSection"));
const FAQSection = lazy(() => import("@/components/sections/FAQSection"));
const ValueOfferSection = lazy(() => import("@/components/sections/ValueOfferSection"));
const Footer = lazy(() => import("@/components/sections/Footer"));

const Index = () => {
  return (
    <main className="relative min-h-screen overflow-x-hidden">
      {/* Aurora Background */}
      <AuroraBackground />

      {/* Navbar */}
      <Navbar />

      {/* Main Content */}
      <div className="relative z-10">
        <HookSection />
        <Suspense fallback={<SectionSkeleton />}>
          <USPSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <ProcessSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <AboutSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <FAQSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <ValueOfferSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton height="h-32" />}>
          <Footer />
        </Suspense>
      </div>
    </main>
  );
};

export default Index;
